export const ProfileType = {
  ADMIN: 1,
  USER: 2,
  DOCTOR: 3,
};